































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapState, mapGetters } from 'vuex'
import BeaconModel from '@/_models/BeaconModel'
import FloorModel from '@/_models/FloorModel'
import gmapsInit from '@/_services/gmap.service'
import MapAdjustBeacon from '@/_services/map.adjust.beacon.service'
import { Constant } from '@/_services/constant'
import _ from 'lodash'

let google: any = {}
let map: any = {}

@Component({
  components: {},
  computed: {},
})
export default class BeaconAdjust extends Vue {
  @Prop()
  singleBeacon!: any
  @Prop()
  // If edit or add new a beacon
  isSingle!: any
  // data
  currentPage: number = 1
  perPage: number = 10
  numofPage: number = 1
  selected: BeaconModel = new BeaconModel()

  selectedFilter: string = 'location_name'
  selectedFilterFloor: string = 'name'

  isFormModalActive: boolean = false
  isSearchFloorActive: boolean = false
  searchQuery: string = ''
  searchQueryFloor: string = ''
  isNew: boolean = false

  name: any = ''
  beaconmarkers: any = []
  editingBeacons: any = []

  selectedFloor: FloorModel = new FloorModel()

  selectedBuildingName: string = ''
  searchQueryBuilding: string = ''

  filedNameLUT: any = {
    _id: 'UUID',
    location_name: 'label.possition',
    major: 'label.major',
    minor: 'label.minor',
    lon: 'label.lon',
    lat: 'label.lat',
    floor_name: 'label.floor',
  }

  filedNameLUTFloor: any = {
    name: 'label.floor_name',
    building_name: 'label.building_name',
  }

  // computed
  get beacons(): BeaconModel[] {
    return this.$store.state.beacons.all.items.filter(
      (item: BeaconModel) => !item.geofence_id
    )
  }

  get floors(): FloorModel[] {
    return this.$store.state.floors.all.items
  }

  get buttonSaveText(): any {
    return this.isNew ? this.$t('button.register') : this.$t('button.save')
  }

  get isLoading(): boolean {
    return this.$store.state.beacons.loading
  }

  get isLoadingFloor(): boolean {
    return this.$store.state.floors.loading
  }

  get filteredDataBeacon(): BeaconModel[] {
    // Edit/add single beacon
    if (this.isSingle) {
      return [this.selected]
    }
    const targetField: string = this.selectedFilter
    if (!this.beacons) {
      return []
    }

    const beacons = this.beacons.filter((item: any): boolean => {
      return (
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.searchQuery.toLowerCase()) !== -1
      )
    })

    this.numofPage = Math.ceil(beacons.length / this.perPage)

    return beacons
  }

  get buildingFloorText(): string {
    return `${this.selectedFloor.building_name}::${this.selectedFloor.name}`
  }

  get filteredDataFloor(): FloorModel[] {
    const targetField: string = this.selectedFilterFloor
    if (!this.floors) {
      return []
    }

    return this.floors.filter((item: any): boolean => {
      return (
        (this.selectedBuildingName === '' ||
          item.building_name === this.selectedBuildingName) &&
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.searchQueryFloor.toLowerCase()) !== -1
      )
    })
  }

  get buildings(): string[] {
    if (!this.floors) {
      return []
    }

    const buildings: string[] = []
    for (const floor of this.floors) {
      if (buildings.indexOf(floor.building_name) === -1) {
        buildings.push(floor.building_name)
      }
    }

    return buildings
  }

  get filteredBuildings(): any[] {
    if (!this.buildings) {
      return []
    }

    return this.buildings.filter((name: string): boolean => {
      return (
        name.toLowerCase().indexOf(this.searchQueryBuilding.toLowerCase()) !==
        -1
      )
    })
  }

  get canDisplayMap(): boolean {
    return !_.isEmpty(this.selectedFloor._id)
  }

  get pinIconSelected(): string {
    return 'https://chart.googleapis.com/chart?chst=d_map_spin&chld=.8|0|00d1b2|18|b|'
  }

  get setIconEditing(): string {
    return 'https://chart.googleapis.com/chart?chst=d_map_spin&chld=.8|0|ff0000|18|b|'
  }

  get pinIcon(): string {
    return 'https://chart.googleapis.com/chart?chst=d_map_spin&chld=.8|0|f9a834|18|b|'
  }

  @Watch('selected')
  async selectedBeacon() {
    for (const marker of this.beaconmarkers) {
      if (marker._id === this.selected._id) {
        marker.setIcon(this.pinIconSelected)
      } else if (this.isEditingBeacon(marker._id)) {
        marker.setIcon(this.setIconEditing)
      } else {
        marker.setIcon(this.pinIcon)
      }
    }
  }

  @Watch('selectedFloor')
  async displayMap() {
    try {
      if (!this.canDisplayMap) {
        return
      }

      if (this.isSingle) {
        this.selected.floor_id = this.selectedFloor._id
        this.selected.floor_name = this.selectedFloor.name
      }

      const el = document.getElementById('beaconMapAdjust')
      if (el === null) {
        return
      }
      const loadingComponent = this.$buefy.loading.open({})
      const center = this.getCenterMap()

      google = await gmapsInit()
      map = new google.maps.Map(el, {
        center,
        zoom: this.selectedFloor.floor_map_zoom,
        tilt: 0,
        clickableIcons: false,
        rotateControl: false,
        streetViewControl: false,
      })

      const bounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(
          this.selectedFloor.floor_sw_lat,
          this.selectedFloor.floor_sw_lon
        ),
        new google.maps.LatLng(
          this.selectedFloor.floor_ne_lat,
          this.selectedFloor.floor_ne_lon
        )
      )

      const overlayOptions = {
        angle: this.selectedFloor.floor_angle,
        floorFile: this.selectedFloor.floor_file,
        floorOpacity: this.selectedFloor.floor_opacity,
      }

      MapAdjustBeacon(google, bounds, map, overlayOptions)

      // Attach beacons to map
      for (const beacon of this.filteredDataBeacon) {
        this.createMarker(beacon)
      }

      loadingComponent.close()
    } catch (error) {
      console.error(error)
    }
  }

  @Watch('selectedBuildingName')
  async selectedBuildingNameChanged(newVal, oldVal) {
    if (oldVal !== '') {
      this.searchQueryFloor = ''
    }
  }

  // methods
  async handleSaveSetting(): Promise<any> {
    const data = new BeaconModel()
    if (this.isSingle) {
      data.lat = this.selected.lat
      data.lon = this.selected.lon
      data.floor_id = this.selected.floor_id
      data.floor_name = this.selected.floor_name
    } else if (this.filteredDataBeacon.length) {
      for (const beacon of this.filteredDataBeacon) {
        await this.$store.dispatch('beacons/updateOne', beacon)
      }
    }

    this.$emit('beaconAdjustDone', data)
  }

  handleChangeFloor(item) {
    this.selectedFloor = item
    this.searchQueryFloor = this.selectedFloor.name
    this.handleChangeBuilding(item.building_name)
  }

  handleChangeBuilding(buildingName) {
    this.searchQueryBuilding = buildingName
    this.selectedBuildingName = buildingName
  }

  handleMoveBeaconToHere(): void {
    for (const marker of this.beaconmarkers) {
      if (this.isSingle || marker._id === this.selected._id) {
        const center = this.getCenterMap()
        this.selected.lat = center.lat
        this.selected.lon = center.lng
        this.selected.floor_id = this.selectedFloor._id
        this.selected.floor_name = this.selectedFloor.name

        this.setEditingBeacon(this.selected)

        marker.setPosition(center)
      }
    }
  }

  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  convertFieldNameFloor(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUTFloor[value]) as string
  }

  createMarker(beacon: BeaconModel) {
    let position
    if (!this.isValidCoord(beacon.lat) || !this.isValidCoord(beacon.lon)) {
      position = this.getCenterMap()
      beacon.lat = position.lat
      beacon.lon = position.lng
    } else {
      position = new google.maps.LatLng(beacon.lat, beacon.lon)
    }
    const marker = new google.maps.Marker({
      position,
      map,
      animation: google.maps.Animation.DROP,
      draggable: true,
      title: beacon._id + ', ' + beacon.location_name,
      icon: this.isSingle ? this.pinIconSelected : this.pinIcon,
    })

    const self = this
    marker.addListener('click', () => {
      self.selected = beacon
    })

    marker._id = beacon._id

    google.maps.event.addListener(marker, 'dragend', (mk) => {
      this.selected = beacon

      const latLng = mk.latLng
      this.selected.lat = latLng.lat()
      this.selected.lon = latLng.lng()
      this.setEditingBeacon(this.selected)
    })

    this.beaconmarkers.push(marker)
  }

  setEditingBeacon(beacon: BeaconModel): void {
    if (this.editingBeacons.indexOf(beacon._id) < 0) {
      this.editingBeacons.push(beacon._id)
    }
  }

  isEditingBeacon(beaconId: string): boolean {
    return this.editingBeacons.indexOf(beaconId) >= 0
  }

  isValidCoord(n) {
    if (typeof n === 'undefined' || n === 0 || n === '') {
      return false
    }

    return true
  }

  getCenterMap(): { lng: number; lat: number } {
    return {
      lat:
        (this.selectedFloor.floor_sw_lat + this.selectedFloor.floor_ne_lat) / 2,
      lng:
        (this.selectedFloor.floor_sw_lon + this.selectedFloor.floor_ne_lon) / 2,
    }
  }

  // After page created
  created() {
    this.$store.dispatch('floors/getAll').then(() => {
      if (!this.filteredDataFloor || !this.filteredDataFloor.length) {
        return
      }

      if (!this.isSingle) {
        this.$store
          .dispatch('beacons/getAll', {
            beacon_type: Constant.BEACON_TYPE_STATIC,
          })
          .then(() => {
            this.handleChangeFloor(this.filteredDataFloor[0])
          })
      } else {
        this.selected = Object.assign({}, this.singleBeacon)
        let isChangedFloor = false
        for (const floor of this.filteredDataFloor) {
          if (floor._id === this.selected.floor_id) {
            this.handleChangeFloor(floor)
            isChangedFloor = true
          }
        }

        if (!isChangedFloor) {
          this.handleChangeFloor(this.filteredDataFloor[0])
        }
      }
    })
  }
}
